var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrevious = function SvgPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.893 5.679 4 3.84c.195.187.451.281.707.281s.512-.094.707-.281a.93.93 0 0 0 0-1.358l-2.293-2.2H11.6c.552 0 1-.43 1-.96 0-.532-.448-.96-1-.96H4.014l2.293-2.202a.93.93 0 0 0 0-1.357 1.03 1.03 0 0 0-1.414 0l-4 3.84a.93.93 0 0 0 0 1.357"
  })));
};
export default SvgPrevious;